import React, {useEffect, useState} from "react";
import Page from "../../Components/Page";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import EditableReactTableV2 from "../../Components/ReactTable/EditableReactTableV2";
import {
    EditFormDropdownInputField,
    EditFormMultiTextInputField,
    EditFormTextInputField
} from "../../Components/ReactTable/EditRecordForm";
import {INDEX_FIELD} from "../../Components/ReactTable/common_custom_columns";
import {checkForDuplicate} from "../serviceUtils";
import {setValuesToNullIfEmptyOrUndefined} from "../../Components/ReactTable/helpers";
import {makeApiCall} from "../../../Api/makeApiCall";
import {getCellForService, getFilterValueForService} from "../../Components/ReactTable/common_dropdown_options";

function MerchantSearch() {

    const [brandOptions, setBrandOptions] = useState([]);
    const [optionsLoading, setOptionsLoading] = useState(true);
    const endpointUrl= `${process.env.REACT_APP_EDP_API_BASE_URL}/mapEnforcementMerchantClients/`;
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});

    const onRowEditConfirmedWrapper = async (newOrUpdatedData) => {
        await onRowEditConfirmed(setValuesToNullIfEmptyOrUndefined(newOrUpdatedData));
    }

    useEffect(() => {
        setOptionsLoading(true);
        makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/brandOnboarding/`)
            .then((data) => {
                const brandOptionsMap = data.map(brand => ({value: brand.brand_id, label: brand.brand_name}))
                setBrandOptions(brandOptionsMap);
            }).finally(() => setOptionsLoading(false));
    }, []);

    const customColumns = [
        {header: "Merchant Id", accessorKey: "merchant_id"},
        {header: "Merchant Name", accessorKey: "merchant_name"},
        {header: "Business Name", accessorKey: "business_name"},
        {header: "Contact Name", accessorKey: "contact_name"},
        {header: "Email", accessorKey: "contact_email"},
        {header: "Phone", accessorKey: "contact_phone"},
        {header: "Address", accessorKey: "address"},
        {header: "Notes", accessorKey: "notes"},
        {
            header: "Merchant Brand",
            accessorKey: "merchant_brand_id",
            cell: ({getValue}) => getCellForService(getValue(), brandOptions),
            filterFn: (row, columnIds, filterValue) => getFilterValueForService(row, columnIds, filterValue, brandOptions),
        }
    ];
    function validatePreSave({rows, form}) {
        const addedNewRow = form.getValues();
        const hasDuplicate =  checkForDuplicate(addedNewRow, rows, 'merchant_id');
        const hasDuplicateBrand =  addedNewRow?.merchant_brand_id ? checkForDuplicate(addedNewRow, rows, 'merchant_brand_id') : false;

        if (hasDuplicate) {
            form.setError('merchant_id', {
                type: 'custom',
                message: [`Merchant Id ${form.getValues('merchant_id')} already exists.`]
            });
        }
        if (hasDuplicateBrand) {
            form.setError('merchant_brand_id', {
                type: 'custom',
                message: [`Merchant Brand ${form.getValues('merchant_brand_id')} already exists.`]
            });
        }
        return !hasDuplicate && !hasDuplicateBrand;
    }
    return (
        <Page name={`Merchant Search`}
              breadCrumbs={<Breadcrumbs items={[{label: "MAP Enforcement"}, {label: "Merchant Search"}]}/>}>
            <LoadingWrapper loading={loading || optionsLoading}>
                <EditableReactTableV2
                    filterable
                    data={data.data}
                    columns={customColumns}
                    editTable={[
                        INDEX_FIELD,
                        {id: "merchant_brand_id", Component: args => <EditFormDropdownInputField  {...args} options={brandOptions} isClearable />},
                        {id: "merchant_id", Component: args => <EditFormTextInputField  {...args} isRequired/>},
                        {id: "merchant_name", Component: args => <EditFormTextInputField  {...args} isRequired/>},
                        {id: "business_name", Component: args => <EditFormTextInputField  {...args}  />},
                        {id: "contact_name", Component: args => <EditFormTextInputField {...args}  />},
                        {id: "contact_phone", Component: args => <EditFormTextInputField  {...args}  />},
                        {id: "contact_email", Component: args => <EditFormTextInputField  {...args}  />},
                        {id: "address", Component: args => <EditFormTextInputField  {...args}  />},
                        {id: "notes", Component: args => <EditFormMultiTextInputField  {...args} label={"Notes"}/>}
                    ]}
                    validatePreSave={validatePreSave}
                    editModalAdditionalClass={"edit-modal-merchant-search-modal"}
                    onRowEditConfirmed={onRowEditConfirmedWrapper}
                    onRowDeleteConfirmed={onRowDeleteConfirmed}
                    initialState={{pagination: {pageSize: 25}, sorting: [{id: "merchant_id", desc: true}]}}
                />
            </LoadingWrapper>
        </Page>
    );
}

export default MerchantSearch;
